import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox } from '@material-ui/core';
import HttpService from '../services/httpService';
import Grid from '@material-ui/core/Grid';
import decorpotLogo from "../assets/img/org/deco_new_logo.png";
// Styles for the component
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }
}));

const GenerateSticker = (props) => {
    const classes = useStyles();
    const [stickerDetails, setStickerDetails] = useState([]);
    const [openDialog, setOpenDialog] = useState(false); // State to manage dialog visibility
    const [selectedIds, setSelectedIds] = useState([]); // State to track selected rows
    const [selectAll, setSelectAll] = useState(false); // State for the "Select All" checkbox
    const [showDownloadButton, setDownloadButton] = useState(false)
    const [activeButton, setActiveButton] = useState('generate'); // 'generate' or 'print'

    // Function to fetch the sticker details based on the id
    const getProjectWiseSticker = async () => {
        const obj = { _id: props.id }; // Use the `id` passed in props
        try {
            setSelectedIds([]);
            setSelectAll(false)
            setActiveButton('generate');
            setDownloadButton(false)
            let res = await HttpService.getProjectWiseSticker(obj);
            let store = res.data.stickerDetails.filter((el) => el?.isSticketGeneated === false)
            setStickerDetails(store); // Set the received data to state
            setOpenDialog(true); // Open dialog when data is received
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
    };

    useEffect(() => {
        if (props.id) {
            getProjectWiseSticker(); // Call the API when the `id` is available
        }
    }, [props.id,props?.forceTrigger]);

    // Handle closing the dialog
    const handleClose = () => {
        setOpenDialog(false);
    };

    // Handle checkbox change for individual items
    const handleCheckboxChange = (id) => {
        setSelectedIds((prevSelectedIds) =>
            prevSelectedIds.includes(id)
                ? prevSelectedIds.filter((item) => item !== id) // Unselect
                : [...prevSelectedIds, id] // Select
        );
    };

    // Handle "Select All" checkbox change
    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedIds([]); // Unselect all
        } else {
            const allIds = stickerDetails.map((item) => item._id);
            setSelectedIds(allIds); // Select all
        }
        setSelectAll(!selectAll); // Toggle the "Select All" state
    };

    // Handle "Generate Barcode" button click
    const handleGenerateBarcode = async () => {
        setActiveButton('generate');
        setDownloadButton(false)
        if (selectedIds.length > 0 && showDownloadButton === false) {
            try {
                const response = await HttpService.generateSticker({ selectedIds });
                getProjectWiseSticker();
                props.setSnackInfo("Sticker Generated Successfull", 'success')
            } catch (error) {
                props.setSnackInfo("Something went wrong",'error')
            }
        } else {
            setSelectAll(false)
            setSelectedIds([]);
            setActiveButton('generate');
            setDownloadButton(false)
            const obj = { _id: props.id }; // Use the `id` passed in props
            try {
                let res = await HttpService.getProjectWiseSticker(obj);
                let store = res.data.stickerDetails.filter((el) => el?.isSticketGeneated === false)
                setStickerDetails(store); // Set the received data to state

            } catch (error) {
                props.setSnackInfo("Something went wrong",'error')
            }
        }
    };

    const handlePrintBarcode = async () => {
        setSelectedIds([]);
        setSelectAll(false)
        const obj = { _id: props.id }; // Use the `id` passed in props
        try {
            let res = await HttpService.getProjectWiseSticker(obj);
            let store = res.data.stickerDetails.filter((el) => el?.isSticketGeneated === true)
            setStickerDetails(store); // Set the received data to state
            setDownloadButton(true)
            setActiveButton('print');

        } catch (error) {
            props.setSnackInfo("Something went wrong",'error')
        }
    };
    const projectNameOptFile = stickerDetails[0]?.projectName || 'No Project Name';
    // Render table rows for the sticker details
    const renderTableRows = () => {
        return stickerDetails.map((item, index) => (       
            <TableRow key={item._id}>
                <TableCell align="center">{index + 1}     <Checkbox
                    checked={selectedIds.includes(item._id)}
                    onChange={() => handleCheckboxChange(item._id)}
                /></TableCell>
                <TableCell align="center">{item.thickness}</TableCell>
                <TableCell align="center">{item.coreMaterial}</TableCell>
                <TableCell align="center">{item.laminate}</TableCell>
                <TableCell align="center">{item.type || 'N/A'}</TableCell>
                <TableCell align="center">{item.size}</TableCell>
                <TableCell align="center">1</TableCell>
                <TableCell align="center">{item.pattern}</TableCell>
                <TableCell align="center">

                </TableCell>
            </TableRow>
        ));
    };

    const convertToBase64 = (url) =>
        fetch(url)
            .then((response) => response.blob())
            .then(
                (blob) =>
                    new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                    })
            );

    const handlePrintBarcodes = async () => {
        setOpenDialog(false)
        const selectedItems = stickerDetails.filter((item) => selectedIds.includes(item._id));
        if (selectedItems.length === 0) {
            alert("No stickers selected for printing!");
            return;
        }

        // Convert the logo to Base64
        const logoBase64 = await convertToBase64(decorpotLogo);

        // Construct the table content
        const tableContent = selectedItems
        .map(
            (item, index) => `
                <div style="page-break-after: always; text-align: center; ">
                    <img src="${logoBase64}" alt="Decorpot Logo" style="width: 250px; "/>
                    <table border="1" cellspacing="0" cellpadding="10" style="width: 100%; border-collapse: collapse; text-align: center; padding: 2px">
                        <tr>
                           <th>Project Code</th>
                            <td style="max-width: 200px; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">${item.projectName || "N/A"}</td>
                        </tr>
                        <tr>
                            <th>Thickness</th>
                            <td>${item.thickness}</td>
                        </tr>
                        <tr>
                            <th>Core Material</th>
                            <td>${item.coreMaterial}</td>
                        </tr>
                        <tr>
                            <th>Laminate</th>
                            <td>${item.laminate}</td>
                        </tr>
                        <tr>
                            <th>Type</th>
                            <td>${item.type || "N/A"}</td>
                        </tr>
                        <tr>
                            <th>Size</th>
                            <td>${item.size}</td>
                        </tr>
                        <tr>
                            <th>Qty</th>
                            <td>1</td>
                        </tr>
                        <tr>
                            <th>Pattern No</th>
                            <td>${item.pattern}</td>
                        </tr>
                    </table>
                </div>
            `
        )
        .join("");

    // Add printable content to a hidden div
    const printDiv = document.createElement("div");
    printDiv.id = "printableArea";
    printDiv.style.display = "none"; // Hide it from the view
    printDiv.innerHTML = `
        <html>
            <head>
                <title>Print Stickers</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        margin: 5px; /* Adds margin around the body */
                    }
                    table {
                        border-collapse: collapse;
                        width: 90%; /* Makes the table take up 90% of the page width */
                        margin: 20px auto; /* Centers the table horizontally and adds vertical margin */
                        margin-top: 5px; /* Adds extra margin from the top */
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 16px; /* Increases padding for a cleaner look */
                        text-align: left;
                    }
                    th {
                        background-color: #f2f2f2;
                    }
                    img {
                        display: block;
                        margin: 0 auto;
                        width: 200px; /* Increases the image width */
                        margin-top: 5px; /* Adds margin above the image */
                    }
                    div {
                        page-break-after: always; /* Ensures each div starts on a new page */
                    }
                </style>
            </head>
            <body>
                ${tableContent}
            </body>
        </html>
    `;
        document.body.appendChild(printDiv);

        // Trigger print
        const printStyles = document.getElementById("printableArea").innerHTML;
        const printFrame = document.createElement("iframe");
        printFrame.style.position = "absolute";
        printFrame.style.top = "-10000px";
        document.body.appendChild(printFrame);

        const printDoc = printFrame.contentWindow || printFrame.contentDocument;
        printDoc.document.open();
        printDoc.document.write(printStyles);
        printDoc.document.close();

        printFrame.onload = () => {
            printDoc.focus();
            printDoc.print();
            document.body.removeChild(printFrame); // Clean up the iframe
            document.body.removeChild(printDiv); // Clean up the hidden div
        };
        setSelectedIds([]);
        setSelectAll(false)
        setActiveButton('generate');
        setDownloadButton(false)
    };

    const generateButtonClass = activeButton === 'generate' ? 'active' : 'inactive';
    const printButtonClass = activeButton === 'print' ? 'active' : 'inactive';



    return (
        <div>
            <Dialog open={openDialog} onClose={handleClose} maxWidth="md" fullWidth>

                <DialogTitle>Sticker Details : {projectNameOptFile}</DialogTitle>
                <DialogContent>
                <div>
            <Grid container spacing={2}>
                <Grid item>
                    <Button
                        variant="contained"
                        color={activeButton === 'generate' ? 'primary' : 'default'}
                        onClick={handleGenerateBarcode}
                        className={generateButtonClass}
                        style={{ marginBottom: 20 }}
                    >
                        Generate Sticker
                    </Button>
                </Grid>

                <Grid item>
                    <Button
                        variant="contained"
                        color={activeButton === 'print' ? 'primary' : 'default'}
                        onClick={handlePrintBarcode}
                        className={printButtonClass}
                        style={{ marginBottom: 20 }}
                    >
                        Print Sticker
                    </Button>
                </Grid>
            </Grid>

            {showDownloadButton === true && (
                <Button variant="contained"
                 color='primary'  
                className={printButtonClass}
                style={{ marginBottom: 20 }}
                 onClick={handlePrintBarcodes}>
                    Print</Button>
            )}
        </div>
                    <TableContainer
                        component={Paper}
                        className={classes.table}
                        style={{ width: "100%" }}
                    >
                        <Table
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">
                                        Sl.No
                                        <Checkbox
                                            checked={selectAll}
                                            onChange={handleSelectAllChange}
                                        /></TableCell>
                                    <TableCell align="center">Thickness</TableCell>
                                    <TableCell align="center">Core Material</TableCell>
                                    <TableCell align="center">Laminate</TableCell>
                                    <TableCell align="center">Type</TableCell>
                                    <TableCell align="center">Size</TableCell>
                                    <TableCell align="center">Qty</TableCell>
                                    <TableCell align="center">Pattern No</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {renderTableRows()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(GenerateSticker);

